import * as React from 'react'
import { DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap'
import { EnhancedFloorHeatingMeasurement } from '@modules/floor-heating/models'
import { useModal } from '@components/modals/use-modal'
import { IconWithText } from '@components/icon-with-text'
import { FloorHeatingParameter } from '@modules/floor-heating/modals/parameter-change-modal'

interface Props {
  selectedRows: EnhancedFloorHeatingMeasurement[]
  clearSelectedRows: () => void
}

export const FloorHeatingTableOptions = ({ selectedRows }: Props): JSX.Element => {
  const isDisabled = !selectedRows.length

  const [showParametersChangeModal] = useModal('FloorHeatingDetailsParametersModalChange')

  const handleParameterChange = (field: FloorHeatingParameter) => () => {
    showParametersChangeModal(null, {
      apartmentIds: selectedRows.map(row => row.apartment_name),
      field,
    })
  }

  return (
    <UncontrolledButtonDropdown disabled={isDisabled}>
      <DropdownToggle color="light" caret={true} disabled={isDisabled}>
        <strong>zaznaczone ({selectedRows.length})</strong>
      </DropdownToggle>
      <DropdownMenu>
        <IconWithText
          icon="uil-pen font-11"
          text="Ustaw temperaturę"
          textClass="font-11"
          onClick={handleParameterChange('temperature')}
        />
      </DropdownMenu>
    </UncontrolledButtonDropdown>
  )
}
